import { Injectable } from '@angular/core';
import { SearchOption } from '../interfaces/searchoption.model';
import { IOffice } from '../interfaces/office.interface';
import { ClaimDialogData } from '../interfaces/claims-dialog.model';
import { IClaim } from '../interfaces/claims.model';
import { OFFICE_CODES } from '../constants/office-codes.constants';

@Injectable({
  providedIn: 'root'
})
export class DialogDataMapperService {
  public mapApiClaimToDialogData(apiClaim: IClaim): ClaimDialogData {
    if (!apiClaim) {
      return {
        client: '',
        sfAccountId: null,
        opportunityOwnerEmail: '',
        opportunityOwnerName: '',
        claimRenewalId: null,
        claimRenewalName: '',
        mainResearchUserId: '',
        mainResearchUserName: '',
        counterSignDate: null,
        officeCode: '',
        officeCodeDisplay: '',
        expiryDate: null,
        claimWording: '',
        claimFootnote: '',
        crmLink: null,
        languageTranslation: null
      };
    }

    const officeName = this.getOfficeNameFromCode(apiClaim.officeCode || '');

    const languageValue =
      apiClaim.languageCode ??
      (apiClaim as any).languageTranslation ??
      null;
    const languageName =
      (apiClaim as any).languageTranslationName ??
      (languageValue ? String(languageValue) : '');

    return {
      claimId: apiClaim.claimId,
      client: apiClaim.client ?? '',
      sfAccountId: apiClaim.salesforceAccountId ?? null,
      opportunityOwnerEmail: apiClaim.opportunityOwner ?? '',
      opportunityOwnerName: apiClaim.opportunityOwnerName ?? '',
      claimRenewalId: apiClaim.renewalClaimId ?? null,
      claimRenewalName: apiClaim.renewalClaimName ?? '',
      mainResearchUserId: apiClaim.mainResearchContactUserId ?? '',
      mainResearchUserName: apiClaim.mainResearchContactUserName ?? '',
      counterSignDate: apiClaim.countersignatureDate ?? null,
      officeCode: apiClaim.officeCode ?? '',
      officeCodeDisplay: officeName,
      expiryDate: apiClaim.expiryDate ?? null,
      claimWording: apiClaim.wording ?? '',
      claimFootnote: apiClaim.footnote ?? '',
      crmLink: apiClaim.crmLink ?? null,
      languageTranslation: languageValue,
      languageTranslationName: languageName,
    };
  }

  public createPrepopulatedOption(id: any, name: string, code: string): SearchOption {
    return {
      id,
      name,
      code
    };
  }

  public createOfficeSearchOption(officeCode: string): Array<SearchOption> {
    const office: IOffice | undefined = OFFICE_CODES.find((o: IOffice) => o.offCode === officeCode);
    if (office) {
      return [{
        id: office.offCode,
        name: office.offName,
        code: office.offCode
      }];
    }
    return [];
  }

  public getOfficeNameFromCode(officeCode: string): string {
    const office = OFFICE_CODES.find(o => o.offCode === officeCode);
    return office ? office.offName : '';
  }

  public getOfficeFromCode(officeCode: string): IOffice {
    const office = OFFICE_CODES.find(o => o.offCode === officeCode);
    return office as IOffice;
  }

  public formatDateForDisplay(value: any): string {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    return date.toLocaleDateString('en-GB');
  }

  public formatDateForApi(value: any): string {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
